module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado8.05b7e0c1.svg";